import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
	data: [],
	loading: false,
};

const getengineeringValueStart = (state) => {
	return updateObject(state, { loading: true });
};

const getengineeringValueSuccess = (state, action) => {
	return updateObject(state, { data: action.data, loading: false });
};

const states = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_ENGINEERINGVALUES_START:
			return getengineeringValueStart(state, action);
		case actionTypes.GET_ENGINEERINGVALUESS_SUCCESS:
			return getengineeringValueSuccess(state, action);

		default:
			return state;
	}
};

export default states;
